import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { Duplicate } from '@insurancemenu/imenu-components-lib/dist/icons';
import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { TemplateInputNameStyled, TemplateNameStyled } from './styles';
import {
  PRODUCT_TEMPLATES_DUPLICATE_MODAL_EXT_NAME_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_DUPLICATE_MODAL_INT_NAME_INPUT_TEST_ID,
  PRODUCT_TEMPLATES_DUPLICATE_MODAL_TEST_ID,
} from '../../constants';

const DuplicateProductTemplateModal = observer((): JSX.Element => {
  const {
    modalLoading,
    isDuplicateModalOpen,
    duplicateTemplateForm,
    currentProductTemplate,
    duplicateProductTemplate,
    closeDuplicateTemplateModal,
    getProductTemplates,
  } = useRFQProductTemplatesStore();

  const convertedCurrentTemplate = toJS(currentProductTemplate);

  const onDuplicateProductTemplate = async (): Promise<void> => {
    await duplicateProductTemplate();
    closeDuplicateTemplateModal();
    void getProductTemplates();
  };

  return (
    <FormModal
      show={isDuplicateModalOpen}
      title="Duplicate Product"
      subtitle={
        <p>
          You are about to create a duplicate of
          <TemplateNameStyled>{convertedCurrentTemplate?.name || 'this'}</TemplateNameStyled>. Please enter the internal
          and external names you&apos;d like to use for the new product.
        </p>
      }
      formContent={
        <>
          <TemplateInputNameStyled
            label="Internal Product Name"
            name="internalName"
            id="internalName"
            value={duplicateTemplateForm.fields.internalName.value}
            onChange={duplicateTemplateForm.onFieldChange}
            width="95%"
            validationPassed={!duplicateTemplateForm.fields.internalName.unpassedValidationMsg}
            validationMessage={duplicateTemplateForm.fields.internalName.unpassedValidationMsg || ''}
            data-test-id={PRODUCT_TEMPLATES_DUPLICATE_MODAL_INT_NAME_INPUT_TEST_ID}
          />
          <TemplateInputNameStyled
            label="External Product Name"
            name="externalName"
            id="externalName"
            value={duplicateTemplateForm.fields.externalName.value}
            onChange={duplicateTemplateForm.onFieldChange}
            width="95%"
            validationPassed={!duplicateTemplateForm.fields.externalName.unpassedValidationMsg}
            validationMessage={duplicateTemplateForm.fields.externalName.unpassedValidationMsg || ''}
            data-test-id={PRODUCT_TEMPLATES_DUPLICATE_MODAL_EXT_NAME_INPUT_TEST_ID}
          />
        </>
      }
      showCloseButton={false}
      onClose={closeDuplicateTemplateModal}
      onSubmit={onDuplicateProductTemplate}
      icon={<Duplicate width="5.6rem" color={colors.green[600]} />}
      isFormValid={duplicateTemplateForm.isFormValid()}
      loading={modalLoading}
      data-test-id={PRODUCT_TEMPLATES_DUPLICATE_MODAL_TEST_ID}
    />
  );
});

export default DuplicateProductTemplateModal;
